module.exports = __webpack_public_path__ + "img/fr.5f3f38c4.png";